import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {translate} from 'views/module';

import TourGuide from './TourGuide';

import Joyride from 'react-joyride';

const MobileGuide = (props) => {
  const {setDrawerOpen} = props;

  const [runTour, setRunTour] = React.useState(() => {
    const completed = localStorage.getItem('tourComplete');
    return completed !== 'true';
  });

  const joyrideSteps1 = [
    {
      target: '#chat-window',
      title: translate('profile.TourGuide.TitleStep1'),
      description: translate('profile.TourGuide.TextStep1'),
      disableBeacon: true,
      placement: 'auto',
    },
    {
      target: '#mobile-button',
      title: translate('profile.TourGuide.TitleStepMobile'),
      description: translate('profile.TourGuide.TextStepMobile'),
      disableBeacon: true,
      placement: 'auto',
    },
  ];

  const joyrideSteps2 = [
    {
      target: '#mobile-form-preview',
      title: translate('profile.TourGuide.TitleStep2'),
      description: translate('profile.TourGuide.TextStep2'),
      disableBeacon: true,
      placement: 'center',
    },
    {
      target: '#form-edit-btn',
      title: translate('profile.TourGuide.TitleStep3'),
      description: translate('profile.TourGuide.TextStep3'),
      disableBeacon: true,
      placement: 'bottom',
      disableOverlay: true,
    },
    {
      target: 'body',
      title: translate('profile.TourGuide.TitleStep4'),
      description: translate('profile.TourGuide.TextStep4'),
      placement: 'center',
    },
  ];

  const [runTour2, setRunTour2] = React.useState(false);

  const handleJoyrideCallback1 = async (data) => {
    if (data.status === 'finished' || data.status === 'skipped') {
      setDrawerOpen(true);
      setTimeout(() => {
        setRunTour2(true);
      }, 500);
      setRunTour(false);
    }
  };

  const handleJoyrideCallback2 = async (data) => {
    if (data.status === 'finished' || data.status === 'skipped') {
      localStorage.setItem('tourComplete', 'true');
      setRunTour2(false);
      setDrawerOpen(false);
    }
  };

  return (
    <>
      <Joyride
        steps={joyrideSteps1}
        run={runTour}
        continuous
        showSkipButton
        disableBeacon
        disableOverlayClose
        disableCloseOnEsc
        tooltipComponent={(data) => (
          <TourGuide
            stepIndex={data.index}
            title={data.step.title}
            description={data.step.description}
            onNext={data.primaryProps.onClick}
            onSkip={data.skipProps.onClick}
            mobile={true}
          />
        )}
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
        callback={handleJoyrideCallback1}
      />
      <Joyride
        steps={joyrideSteps2}
        run={runTour2}
        continuous
        showSkipButton
        disableBeacon
        disableOverlayClose
        disableCloseOnEsc
        tooltipComponent={(data) => (
          <TourGuide
            stepIndex={data.index + 2}
            title={data.step.title}
            description={data.step.description}
            onNext={data.primaryProps.onClick}
            onSkip={data.skipProps.onClick}
            mobile={true}
          />
        )}
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
        callback={handleJoyrideCallback2}
      />
    </>
  );
};

MobileGuide.propTypes = {
  setDrawerOpen: PropTypes.func,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(MobileGuide));
